
/**
 * @file Signup form container
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions';
import Form from '../components/form';


class FormContainer extends Component {
  render() {
    return (
      <Form {...this.props}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUsernameChange: (username) => {
      dispatch(actions.changeUsername({ username }))
    },
    onEmailChange: (email) => {
      dispatch(actions.changeEmail({ email }))
    },
    onPasswordChange: (password) => {
      dispatch(actions.changePassword({ password }))
    },
    onUsernameValidate: (url) => {
      dispatch(actions.usernameValidation(url))
    },
    onEmailValidate: (url) => {
      dispatch(actions.emailValidation(url))
    },
    onPasswordValidate: () => {
      dispatch(actions.validatePassword())
    },
    onFormSubmit: (evt) => {
      dispatch(actions.submitForm(evt))
    }
  }
}

/**
 *
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormContainer)
